var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from 'pinia';
import { abandonCart, fetchBasicCartData, fetchDetailedCartData } from '@resources/scripts/services/cart.service';
// eslint-disable-next-line import/prefer-default-export
export const useCartStore = defineStore({
    id: 'cart',
    state: () => ({
        basicCartData: {},
        cartDetails: {},
        loading: false,
    }),
    getters: {
        packagesForSubject: (state) => (subjectId) => state.cartDetails.cartPackages.filter((p) => p.subjectId === subjectId),
        subjects: (state) => state.cartDetails.subjects || [],
    },
    actions: {
        loadBasicData() {
            return __awaiter(this, void 0, void 0, function* () {
                this.basicCartData = yield fetchBasicCartData();
            });
        },
        loadDetailedCartData(payload = { showLoader: true }) {
            return __awaiter(this, void 0, void 0, function* () {
                this.loading = payload.showLoader;
                this.cartDetails = yield fetchDetailedCartData();
                this.basicCartData = this.cartDetails.cartData;
                this.loading = false;
            });
        },
        abandon() {
            return __awaiter(this, void 0, void 0, function* () {
                yield abandonCart();
                yield this.loadBasicData();
                yield this.loadDetailedCartData();
            });
        },
    },
});
